module.exports = __webpack_public_path__ + "static/media/country_mk.3e56609b.webp";